import { decodeFA, DropdownMenu, themeOptions } from "@swivu/shared-ui";
import { useSettings } from "../hooks/useSettings.js";

const ThemeMenu = () => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger className="  flex items-center gap-3 text-sm font-bold outline-none ring-0  ">
        <i
          className={`size-4 text-mono-700 dark:text-mono-400 fa-regular ${decodeFA(
            "gear"
          )}`}
        />
        <span className="sr-only">Theme</span>
        <span>Settings</span>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align="start" side="top" className="w-52">
        {/* <DropdownMenu.Group> */}
        {/*<InformationDensity />*/}
        <Theme />
        {/*<BoardsSelectionDropdown />*/}
        {/*<DropdownMenu.Separator />*/}
        {/* </DropdownMenu.Group> */}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};

function Theme() {
  const { theme, updateSettings } = useSettings();

  return (
    <DropdownMenu.RadioGroup
      value={theme}
      onValueChange={(newTheme) => {
        updateSettings({ theme: newTheme as typeof theme });
      }}
    >
      {themeOptions.map((option) => (
        <DropdownMenu.RadioItem value={option.value} key={option.value}>
          {option.text}
        </DropdownMenu.RadioItem>
      ))}
    </DropdownMenu.RadioGroup>
  );
}

export default ThemeMenu;
